module.exports = __webpack_public_path__ + "img/Jianlong_Fu@2x.a5e1d9dc.png";